import { createSaleHistoryExporter } from './sales/exportSaleHistory';

const exporter = createSaleHistoryExporter({
  title: 'Guest Pass List',
  itemLabel: 'Guest Pass',
  slug: 'guest-passes',
});

export const printGuestPassList = (data) => exporter.print(data);
export const exportGuestPassCsv = (data) => exporter.csv(data);
export const exportGuestPassExcel = (data) => exporter.excel(data);
export const exportGuestPassPdf = (data) => exporter.pdf(data);
export const exportGuestPasses = (data) => exporter.exportAll(data);
